// Runtime patch for Bootstrap Modal to avoid crashes when Blazor removes modal elements
// while a hide transition callback is still pending.

(function () {
  function patchModal() {
    const bs = window.bootstrap;
    const Modal = bs && bs.Modal;

    if (!Modal || Modal.__isrPatched) {
      return;
    }

    const proto = Modal.prototype;

    // Patch _hideModal (the crash point in the stack trace)
    if (proto && typeof proto._hideModal === 'function') {
      const originalHideModal = proto._hideModal;
      proto._hideModal = function () {
        // In Blazor, element can be removed before transition completes.
        if (!this || !this._element || !this._element.style) {
          try {
            // Best-effort cleanup of leftover artifacts.
            if (window.bootstrapModalCleanup && typeof window.bootstrapModalCleanup.cleanupModalArtifacts === 'function') {
              window.bootstrapModalCleanup.cleanupModalArtifacts();
            }
          } catch {
            // ignore
          }
          return;
        }

        return originalHideModal.apply(this, arguments);
      };
    }

    // Patch hide() similarly so we don't queue callbacks on a missing element.
    if (proto && typeof proto.hide === 'function') {
      const originalHide = proto.hide;
      proto.hide = function () {
        if (!this || !this._element) {
          return;
        }
        return originalHide.apply(this, arguments);
      };
    }

    Modal.__isrPatched = true;
  }

  // Bootstrap is loaded before our app JS bundle in this app; patch immediately.
  // Also retry on DOMContentLoaded in case script ordering changes.
  patchModal();
  document.addEventListener('DOMContentLoaded', patchModal);
})();
